import AccountDetailsSymbols from "../symbols/accountDetails";

const initialState = {
  data: {},
  loading: false,
  error: false,
};

export default function AccountDetailsReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case AccountDetailsSymbols.ACCOUNT_DETAILS:
      return { ...state, loading: true, error: false };
    case AccountDetailsSymbols.ACCOUNT_DETAILS_SUCCESS:
      return {
        ...state,
        data: action.payload.Result,
        loading: false,
        error: false,
      };
    case AccountDetailsSymbols.ACCOUNT_DETAILS_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case AccountDetailsSymbols.CLEAR_ACCOUNT_DETAILS:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
